module.exports = __webpack_public_path__ + "static/media/iconCheckBox.3e517f87.svg";